/* header navi jos läpinäkyvä 

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('x-header.header');
  if (!header) return;

  const DARK_COLOR = '43 43 46';

  function getActiveSlideshowColor() {
    const slideshows = document.querySelectorAll('.slideshow');
    for (const slideshow of slideshows) {
      const rect = slideshow.getBoundingClientRect();
      const headerHeight = header.offsetHeight;
      if (rect.top <= headerHeight && rect.bottom > headerHeight) {
        const activeSlide = slideshow.querySelector('.slideshow__slide.is-selected');
        if (!activeSlide) continue;
        const slideContent = activeSlide.querySelector('.slideshow__slide-content');
        if (!slideContent) continue;
        return slideContent.style.getPropertyValue('--text-color').trim();
      }
    }
    return null;
  }

  function applySecondaryNavColor(color) {
    header.querySelectorAll('.header__secondary-nav .link-faded, .header__secondary-nav .link-faded svg').forEach(el => {
      if (color) {
        el.style.setProperty('color', `rgb(${color})`, 'important');
      } else {
        el.style.removeProperty('color');
      }
    });
    header.querySelectorAll('.header__secondary-nav .link-faded svg path, .header__secondary-nav .link-faded svg circle, .header__secondary-nav .link-faded svg line, .header__secondary-nav .link-faded svg polyline').forEach(el => {
      if (color) {
        el.style.setProperty('stroke', `rgb(${color})`, 'important');
      } else {
        el.style.removeProperty('stroke');
      }
    });
  }

  function isMegaMenuOpen() {
    return !!header.querySelector('.header__menu-disclosure[open]');
  }

  function isSearchOpen() {
    return !!header.querySelector('a[aria-expanded="true"]');
  }

  function isOverlayOpen() {
    return isMegaMenuOpen() || isSearchOpen();
  }

  let currentColor = null;

  function updateHeader() {
    const textColor = getActiveSlideshowColor();
    currentColor = textColor;

    if (isOverlayOpen()) {
      header.classList.add('header--mega-open');
      header.classList.remove('header--over-slideshow');
      header.style.removeProperty('--header-text-color');
      applySecondaryNavColor(DARK_COLOR);
      return;
    }

    header.classList.remove('header--mega-open');

    if (textColor) {
      header.style.setProperty('--header-text-color', textColor);
      header.classList.add('header--over-slideshow');
    } else {
      header.classList.remove('header--over-slideshow');
      header.style.removeProperty('--header-text-color');
    }
    applySecondaryNavColor(textColor);
  }

  let rafPending = false;
  function scheduleUpdate() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(() => {
        updateHeader();
        rafPending = false;
      });
    }
  }

  updateHeader();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });

  header.addEventListener('mouseenter', () => {
    requestAnimationFrame(() => {
      if (isOverlayOpen()) {
        applySecondaryNavColor(DARK_COLOR);
      } else if (currentColor) {
        applySecondaryNavColor(currentColor);
      }
    });
  });

  header.querySelectorAll('.header__menu-disclosure').forEach(disclosure => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(disclosure, { attributes: true, attributeFilter: ['open'] });
  });

  header.querySelectorAll('a[aria-controls]').forEach(link => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });
  });

  document.querySelectorAll('.slideshow').forEach(slideshow => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(slideshow, { attributes: true, subtree: true, attributeFilter: ['class'] });
  });
});
*/

/* header navi jos läpinäkyvä */

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('x-header.header');
  if (!header) return;

  const DARK_COLOR = '43 43 46';

  function getActiveSlideshowColor() {
    const slideshows = document.querySelectorAll('.slideshow');
    for (const slideshow of slideshows) {
      const rect = slideshow.getBoundingClientRect();
      const headerHeight = header.offsetHeight;
      if (rect.top <= headerHeight && rect.bottom > headerHeight) {
        const activeSlide = slideshow.querySelector('.slideshow__slide.is-selected');
        if (!activeSlide) continue;
        const slideContent = activeSlide.querySelector('.slideshow__slide-content');
        if (!slideContent) continue;
        return slideContent.style.getPropertyValue('--text-color').trim();
      }
    }
    return null;
  }

  function applySecondaryNavColor(color) {
    if (window.innerWidth < 1000) return;
    header.querySelectorAll('.header__secondary-nav .link-faded:not(.button), .header__secondary-nav .link-faded:not(.button) svg').forEach(el => {
      if (el.closest('.button')) return;
      if (color) {
        el.style.setProperty('color', `rgb(${color})`, 'important');
      } else {
        el.style.removeProperty('color');
      }
    });
    header.querySelectorAll('.header__secondary-nav .link-faded:not(.button) svg path, .header__secondary-nav .link-faded:not(.button) svg circle, .header__secondary-nav .link-faded:not(.button) svg line, .header__secondary-nav .link-faded:not(.button) svg polyline').forEach(el => {
      if (el.closest('.button')) return;
      if (color) {
        el.style.setProperty('stroke', `rgb(${color})`, 'important');
      } else {
        el.style.removeProperty('stroke');
      }
    });
  }

  function isMegaMenuOpen() {
    return !!header.querySelector('.header__menu-disclosure[open]');
  }

  function isSearchOpen() {
    return !!header.querySelector('a[aria-expanded="true"]');
  }

  function isOverlayOpen() {
    return isMegaMenuOpen() || isSearchOpen();
  }

  let currentColor = null;

  function updateHeader() {
    const textColor = getActiveSlideshowColor();
    currentColor = textColor;

    if (isOverlayOpen()) {
      header.classList.add('header--mega-open');
      header.classList.remove('header--over-slideshow');
      header.style.removeProperty('--header-text-color');
      applySecondaryNavColor(DARK_COLOR);
      return;
    }

    header.classList.remove('header--mega-open');

    if (textColor) {
      header.style.setProperty('--header-text-color', textColor);
      header.classList.add('header--over-slideshow');
    } else {
      header.classList.remove('header--over-slideshow');
      header.style.removeProperty('--header-text-color');
    }
    applySecondaryNavColor(textColor);
  }

  let rafPending = false;
  function scheduleUpdate() {
    if (!rafPending) {
      rafPending = true;
      requestAnimationFrame(() => {
        updateHeader();
        rafPending = false;
      });
    }
  }

  updateHeader();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });

  header.addEventListener('mouseenter', () => {
    requestAnimationFrame(() => {
      if (isOverlayOpen()) {
        applySecondaryNavColor(DARK_COLOR);
      } else if (currentColor) {
        applySecondaryNavColor(currentColor);
      }
    });
  });

  header.querySelectorAll('.header__menu-disclosure').forEach(disclosure => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(disclosure, { attributes: true, attributeFilter: ['open'] });
  });

  header.querySelectorAll('a[aria-controls]').forEach(link => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(link, { attributes: true, attributeFilter: ['aria-expanded'] });
  });

  document.querySelectorAll('.slideshow').forEach(slideshow => {
    const observer = new MutationObserver(scheduleUpdate);
    observer.observe(slideshow, { attributes: true, subtree: true, attributeFilter: ['class'] });
  });

  new MutationObserver(function () {
    header.querySelectorAll('button[form="predictive-search-form"]').forEach(function (btn) {
      btn.style.setProperty('color', '#fdfdfa', 'important');
    });
  }).observe(header, { childList: true, subtree: true });
});






// reviews

(function () {
  let overlay, drawer, initialized = false;

  function initDrawer(reviewWidget) {
    if (initialized) return;
    initialized = true;

    overlay = document.createElement('div');
    overlay.className = 'reviews-drawer-overlay';

    drawer = document.createElement('div');
    drawer.className = 'reviews-drawer';
    var reviewsTitle = (document.documentElement.lang || '').startsWith('fi') ? 'Arvostelut' : 'Reviews';
drawer.innerHTML = '<div class="reviews-drawer__header"><p class="reviews-drawer__title">' + reviewsTitle + '</p><button class="reviews-drawer__close" aria-label="Sulje">✕</button></div>';

    drawer.appendChild(reviewWidget);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    overlay.addEventListener('click', closeDrawer);
    drawer.querySelector('.reviews-drawer__close').addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (e) {
    const badge = e.target.closest('[data-widget-name="preview_badge"]');
    if (badge) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer();
    }
  }, true);

  function tryInit() {
    const widget = document.querySelector('.jdgm-widget[data-widget="review"]');
    if (widget) {
      initDrawer(widget);
      return true;
    }
    return false;
  }

  if (!tryInit()) {
    const observer = new MutationObserver(function () {
      if (tryInit()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();


//sticky perestige add to cart all the time desktop

(function () {
  const stickyBar = document.querySelector('product-sticky-bar');
  if (!stickyBar) return;

  const addToCartBtn =
    document.querySelector('.product-form__submit') ||
    document.querySelector('form[id*="product-form-main"] button[type="submit"]');

  let atcVisible = true;

  if (addToCartBtn) {
    new IntersectionObserver(function (entries) {
      atcVisible = entries[0].isIntersecting;
      if (atcVisible) {
        stickyBar.classList.remove('is-visible');
      }
    }, { threshold: 0 }).observe(addToCartBtn);
  }

  new MutationObserver(function () {
    if (!atcVisible && !stickyBar.classList.contains('is-visible')) {
      stickyBar.classList.add('is-visible');
    }
  }).observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
})();



/* Sivu modlait

(function () {
  const accordions = document.querySelectorAll('.product-info .accordion__disclosure');
  if (!accordions.length) return;

  const overlay = document.createElement('div');
  overlay.className = 'info-drawer-overlay';

  const drawer = document.createElement('div');
  drawer.className = 'info-drawer';
  drawer.innerHTML = '<div class="info-drawer__header"><p class="info-drawer__title"></p><button class="info-drawer__close" aria-label="Sulje">✕</button></div><div class="info-drawer__content"></div>';

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  const titleEl = drawer.querySelector('.info-drawer__title');
  const contentEl = drawer.querySelector('.info-drawer__content');

  function openDrawer(title, contentNode) {
    titleEl.textContent = title;
    contentEl.innerHTML = '';
    contentEl.appendChild(contentNode.cloneNode(true));
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', closeDrawer);
  drawer.querySelector('.info-drawer__close').addEventListener('click', closeDrawer);

  accordions.forEach(function (accordion) {
    const summary = accordion.querySelector('summary');
    const body = accordion.querySelector(':scope > *:not(summary)');
    if (!summary || !body) return;

    const title = summary.textContent.trim();

    summary.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      openDrawer(title, body);
    }, true);
  });
})();

*/

// vain yksi accordion

(function () {
  if (!document.querySelector('.product-info')) return;

  const accordions = document.querySelectorAll('.product-info .accordion__disclosure');
  accordions.forEach(function (accordion) {
    accordion.addEventListener('toggle', function () {
      if (this.open) {
        accordions.forEach(function (other) {
          if (other !== accordion && other.open) {
            other.querySelector('summary').click();
          }
        });
      }
    });
  });
})();

// slideshow linkki

(function () {
  document.addEventListener('click', function (e) {
    if (e.target.closest('a, button')) return;
    var slide = e.target.closest('.slideshow__slide[data-link]');
    if (!slide) return;
    window.location.href = slide.dataset.link;
  });
})();


// footer fix

(function () {
  function stickyFooter() {
    var footer = document.querySelector('.shopify-section-group-footer-group');
    if (!footer) return;
    footer.style.marginTop = '';
    var gap = window.innerHeight - footer.getBoundingClientRect().bottom;
    if (gap > 0) {
      footer.style.marginTop = gap + 'px';
    }
  }
  window.addEventListener('load', stickyFooter);
  window.addEventListener('resize', stickyFooter);
})();


// Kiwi custom toimii simppeli ilman carttia

/* Kiwi - custom.js piti toimii kun avaa monesti

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.createElement('div');
    overlay.className = 'kiwi-drawer-overlay';
    var drawer = document.createElement('div');
    drawer.className = 'kiwi-drawer';
    var header = document.createElement('div');
    header.className = 'kiwi-drawer__header';
    var drawerTitle = document.createElement('div');
    drawerTitle.className = 'kiwi-drawer__title';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'kiwi-drawer__close';
    closeBtn.setAttribute('aria-label', 'Sulje');
    closeBtn.textContent = '✕';
    header.appendChild(drawerTitle);
    header.appendChild(closeBtn);
    var content = document.createElement('div');
    content.className = 'kiwi-drawer__content';
    drawer.appendChild(header);
    drawer.appendChild(content);
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    var scrollY = 0;
    var opening = false;

    function openDrawer(modal) {
      scrollY = window.scrollY;
      if (window.innerWidth < 1000) {
        document.body.style.top = '-' + scrollY + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }
      modal.style.setProperty('display', 'block', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      var inner = modal.querySelector('.kiwi-sizing-modal-inner');
      if (inner) {
        inner.style.setProperty('transform', 'none', 'important');
        inner.style.setProperty('opacity', '1', 'important');
        inner.style.setProperty('visibility', 'visible', 'important');
        inner.style.removeProperty('height');
      }
      modal.querySelectorAll('.ks-modal-content-wrapper, .ks-modal-content').forEach(function (el) {
        el.style.removeProperty('height');
      });
      var titleEl = modal.querySelector('.modal-title-header');
      drawerTitle.textContent = titleEl ? titleEl.textContent : '';
      content.innerHTML = '';
      content.appendChild(modal);
      requestAnimationFrame(function () {
        if (inner) {
          inner.style.setProperty('transform', 'none', 'important');
          inner.style.setProperty('opacity', '1', 'important');
        }
      });
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    }

    function closeDrawer() {
      drawerTitle.textContent = '';
      var kiwiModal = content.querySelector('.kiwi-sizing-modal');
      if (kiwiModal) {
        kiwiModal.style.removeProperty('display');
        kiwiModal.style.removeProperty('visibility');
        document.body.appendChild(kiwiModal);
      }
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      if (window.innerWidth < 1000) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
      requestAnimationFrame(function () {
        window.dispatchEvent(new Event('scroll'));
      });
    }

    function dismissKiwi() {
      var kiwiTop = document.body.style.top;
      document.documentElement.classList.remove('kiwi-sizing-modal-visible');
      document.documentElement.removeAttribute('modal');
      document.body.classList.remove('fixed-on-mobile', 'kiwi-modal-style-0');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (kiwiTop) window.scrollTo(0, Math.abs(parseInt(kiwiTop) || 0));
    }

    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close], .ks-modal-close')) {
        e.preventDefault();
        closeDrawer();
      }
    }, true);

    new MutationObserver(function () {
      var isOpen = document.documentElement.classList.contains('kiwi-sizing-modal-visible');

      if (!isOpen) {
        if (!opening && drawer.classList.contains('is-open')) closeDrawer();
        return;
      }

      opening = true;
      setTimeout(function () { opening = false; }, 0);

      var modal = document.querySelector('.kiwi-sizing-modal');
      if (!modal) return;

      if (modal.children.length > 0) {
        dismissKiwi();
        openDrawer(modal);
      } else {
        new MutationObserver(function (_, mo) {
          if (modal.children.length > 0) {
            mo.disconnect();
            dismissKiwi();
            openDrawer(document.querySelector('.kiwi-sizing-modal'));
          }
        }).observe(modal, { childList: true, subtree: true });
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  });
})();*/

// Kiwi drawer

/*
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var overlay = document.createElement('div');
    overlay.className = 'kiwi-drawer-overlay';
    var drawer = document.createElement('div');
    drawer.className = 'kiwi-drawer';
    var header = document.createElement('div');
    header.className = 'kiwi-drawer__header';
    var drawerTitle = document.createElement('div');
    drawerTitle.className = 'kiwi-drawer__title';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'kiwi-drawer__close';
    closeBtn.setAttribute('aria-label', 'Sulje');
    closeBtn.textContent = '✕';
    header.appendChild(drawerTitle);
    header.appendChild(closeBtn);
    var content = document.createElement('div');
    content.className = 'kiwi-drawer__content';
    drawer.appendChild(header);
    drawer.appendChild(content);
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    var scrollY = 0;
    var clickedInDrawer = false;
    var clickTimer = null;
    var closing = false;
    var guardRafId = null;

    function dismissKiwi() {
      document.documentElement.classList.remove('kiwi-sizing-modal-visible');
      document.documentElement.removeAttribute('modal');
      document.body.classList.remove('fixed-on-mobile', 'kiwi-modal-style-0');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
    }

    function stopGuard() {
      if (guardRafId) { cancelAnimationFrame(guardRafId); guardRafId = null; }
    }

    function startGuard() {
      stopGuard();
      function loop() {
        if (closing || !drawer.classList.contains('is-open')) { guardRafId = null; return; }
        var m = document.querySelector('.kiwi-sizing-modal');
        if (m && m.parentElement !== content) {
          content.innerHTML = '';
          content.appendChild(m);
          m.style.setProperty('display', 'block', 'important');
          m.style.setProperty('visibility', 'visible', 'important');
          var i = m.querySelector('.kiwi-sizing-modal-inner');
          if (i) {
            i.style.setProperty('opacity', '1', 'important');
            i.style.setProperty('visibility', 'visible', 'important');
            i.style.setProperty('transform', 'none', 'important');
          }
        }
        guardRafId = requestAnimationFrame(loop);
      }
      guardRafId = requestAnimationFrame(loop);
    }

    function openDrawer(modal) {
      closing = false;
      scrollY = window.scrollY;
      if (window.innerWidth < 1000) {
        document.body.style.top = '-' + scrollY + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
      }
      modal.style.setProperty('display', 'block', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      var inner = modal.querySelector('.kiwi-sizing-modal-inner');
      if (inner) {
        inner.style.setProperty('transform', 'none', 'important');
        inner.style.setProperty('opacity', '1', 'important');
        inner.style.setProperty('visibility', 'visible', 'important');
        inner.style.removeProperty('height');
      }
      modal.querySelectorAll('.ks-modal-content-wrapper, .ks-modal-content').forEach(function (el) {
        el.style.removeProperty('height');
      });
      var titleEl = modal.querySelector('.modal-title-header');
      drawerTitle.textContent = titleEl ? titleEl.textContent : '';
      content.innerHTML = '';
      content.appendChild(modal);
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      startGuard();
      requestAnimationFrame(function () {
        if (inner) {
          inner.style.setProperty('transform', 'none', 'important');
          inner.style.setProperty('opacity', '1', 'important');
        }
        window.dispatchEvent(new Event('resize'));
      });
    }

    function closeDrawer() {
      closing = true;
      stopGuard();
      clearTimeout(clickTimer);
      clickedInDrawer = false;
      drawerTitle.textContent = '';
      var kiwiModal = content.querySelector('.kiwi-sizing-modal');
      if (kiwiModal) {
        kiwiModal.style.removeProperty('display');
        kiwiModal.style.removeProperty('visibility');
        document.body.appendChild(kiwiModal);
      }
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      if (window.innerWidth < 1000) {
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
      dismissKiwi();
      requestAnimationFrame(function () {
        window.dispatchEvent(new Event('scroll'));
      });
    }

    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);

    drawer.addEventListener('mousedown', function () {
      clickedInDrawer = true;
      clearTimeout(clickTimer);
      clickTimer = setTimeout(function () { clickedInDrawer = false; }, 2000);
    }, true);

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-modal-close], .ks-modal-close')) {
        e.preventDefault();
        e.stopPropagation();
        closeDrawer();
      }
    }, true);

    new MutationObserver(function () {
      var isOpen = document.documentElement.classList.contains('kiwi-sizing-modal-visible');

      if (!isOpen) {
        if (clickedInDrawer && drawer.classList.contains('is-open')) closeDrawer();
        return;
      }

      var modal = document.querySelector('.kiwi-sizing-modal');
      if (!modal) return;

      if (modal.parentElement === content) {
        dismissKiwi();
        return;
      }

      if (modal.children.length > 0) {
        dismissKiwi();
        openDrawer(modal);
      } else {
        new MutationObserver(function (_, mo) {
          if (modal.children.length > 0) {
            mo.disconnect();
            dismissKiwi();
            openDrawer(document.querySelector('.kiwi-sizing-modal'));
          }
        }).observe(modal, { childList: true, subtree: true });
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  });
})(); */

/* ============================================
   PRODUCT CARD – HORIZONTAL MEDIA HOVER
   Optimized / Desktop only
   ============================================ */

(() => {
  const desktop = window.matchMedia(
    '(min-width: 1000px) and (hover: hover) and (pointer: fine)'
  );

  const states = new WeakMap();
  let active = null;

  function getState(card) {
    if (states.has(card)) return states.get(card);

    const overlay = card.querySelector('.pk-hover-media');
    const link = card.querySelector('.product-card__media');

    if (!overlay || !link) return null;

    const items = [...overlay.querySelectorAll('[data-type]')];
    const display = overlay.querySelector('.pk-hover-media__display');

    if (!display || items.length < 2) return null;

    const state = {
      link,
      overlay,
      display,
      items,
      media: new Map(),
      ready: new Map(),
      index: -1,
      current: null,
      requestId: 0
    };

    states.set(card, state);
    return state;
  }

  function createMedia(item) {
    const src = item.dataset.src;

    if (item.dataset.type === 'video') {
      const video = document.createElement('video');

      video.src = src;
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      video.disablePictureInPicture = true;
      video.setAttribute('aria-hidden', 'true');

      return video;
    }

    const img = document.createElement('img');

    img.src = src;
    img.alt = '';
    img.decoding = 'async';
    img.loading = 'eager';

    return img;
  }

  function prepareMedia(state, index) {
    if (!state.media.has(index)) {
      state.media.set(
        index,
        createMedia(state.items[index])
      );
    }

    return state.media.get(index);
  }

  function waitUntilReady(state, index, media) {
    if (state.ready.has(index)) {
      return state.ready.get(index);
    }

    let promise;

    if (media.tagName === 'IMG') {
      promise = media.decode()
        .then(() => true)
        .catch(() => media.complete && media.naturalWidth > 0);
    } else {
      promise = new Promise((resolve) => {
        if (media.readyState >= 2) {
          resolve(true);
          return;
        }

        const cleanup = () => {
          media.removeEventListener('loadeddata', onReady);
          media.removeEventListener('error', onError);
        };

        const onReady = () => {
          cleanup();
          resolve(true);
        };

        const onError = () => {
          cleanup();
          resolve(false);
        };

        media.addEventListener('loadeddata', onReady);
        media.addEventListener('error', onError);

        media.preload = 'auto';
        media.load();
      });
    }

    state.ready.set(index, promise);
    return promise;
  }

  function reset(state) {
    if (!state) return;

    state.requestId++;
    state.index = -1;
    state.current = null;

    state.overlay.classList.remove('is-active');

    state.media.forEach((media) => {
      if (media.tagName === 'VIDEO') media.pause();
    });

    if (active === state) active = null;
  }

  async function showMedia(state, index) {
    if (index === state.index) return;

    state.index = index;
    const requestId = ++state.requestId;

    const next = prepareMedia(state, index);
    const ready = await waitUntilReady(state, index, next);

    if (
      !ready ||
      requestId !== state.requestId ||
      active !== state ||
      !desktop.matches ||
      !state.link.matches(':hover')
    ) {
      return;
    }

    if (!state.display.contains(next)) {
      next.style.zIndex = '0';
      state.display.appendChild(next);
    }

    const previous = state.current;

    if (previous === next) return;

    state.media.forEach((media) => {
      if (state.display.contains(media)) {
        media.style.zIndex = media === next ? '2' : '1';
      }
    });

    state.current = next;
    state.overlay.classList.add('is-active');

    if (previous?.tagName === 'VIDEO') {
      previous.pause();
    }

    if (next.tagName === 'VIDEO') {
      try {
        next.currentTime = 0;
      } catch (error) {}

      next.play().catch(() => {});
    }
  }

  function handleMove(event, link) {
    if (!desktop.matches || event.pointerType !== 'mouse') {
      return;
    }

    const card = link.closest('.product-card');
    if (!card) return;

    const state = getState(card);
    if (!state) return;

    if (active && active !== state) {
      reset(active);
    }

    active = state;

    const rect = link.getBoundingClientRect();

    if (!rect.width) return;

    const progress = Math.max(
      0,
      Math.min(
        0.999999,
        (event.clientX - rect.left) / rect.width
      )
    );

    const index = Math.floor(progress * state.items.length);

    showMedia(state, index);
  }

  /*
   * Event delegation supports Shopify dynamic
   * product cards without individual listeners.
   */
  document.addEventListener('pointerover', (event) => {
    const link = event.target.closest?.('.product-card__media');
    if (!link || !desktop.matches) return;

    handleMove(event, link);
  });

  document.addEventListener('pointermove', (event) => {
    const link = event.target.closest?.('.product-card__media');
    if (!link) return;

    handleMove(event, link);
  });

  document.addEventListener('pointerout', (event) => {
    if (!active) return;

    const link = active.link;

    if (
      link.contains(event.target) &&
      (!event.relatedTarget || !link.contains(event.relatedTarget))
    ) {
      reset(active);
    }
  });

  window.addEventListener('blur', () => reset(active));

  desktop.addEventListener('change', () => {
    if (!desktop.matches) reset(active);
  });
})();














































